import { httpClient } from '../http/httpClient'

export interface CreateReferralBody {
  cpf: string
  referral: string
  name?: string
  email?: string
  phone?: string
  myTeam?: boolean
}

export async function createReferral(body: CreateReferralBody) {
  const { data } = await httpClient.post<{ success: boolean }>(
    'user/referral',
    body,
  )

  return data
}
